import React, { useEffect, useState } from 'react';
import { User } from '@apply/store/src/user/types';

export const Greeting: React.FC<{ user: User }> = ({ user }) => {
    const sessionVariable = 'GreetingDisplayedPreviously';
    const [displayMessage, set_displayMessage] = useState(true);
    const [initialLoad, set_initialLoad] = useState(true);

    const shouldDisplayMessage = window.sessionStorage.getItem(sessionVariable) == 'true' ? false : true;

    useEffect(() => {
        if (initialLoad) {
            set_displayMessage(shouldDisplayMessage);
            set_initialLoad(false);
        } else {
            window.sessionStorage.setItem(sessionVariable, 'true');
        }
    });

    return <>{displayMessage && <h1>Welcome Back, {user?.firstName}</h1>}</>;
};
